import { useBaseApiCall } from '@/api/factory/base/api';
import { useHandleMutationError } from '@/api/utils';
import { useAddToast } from '@/components/base/toast/use-toast';
import type { SocialMediaLogin } from '@/types/social-media-login';
import { useMutation } from '@tanstack/react-query';

interface SocialMediaLoginMutationData {
  redirectUrl: string;
}

interface SocialMediaLoginMutationVariables {
  type: SocialMediaLogin;
  callOutPath: string;
}

export const useSocialMedialLoginMutation = () => {
  const mutationFn = useBaseApiCall<
    SocialMediaLoginMutationData,
    [SocialMediaLoginMutationVariables]
  >((api, { callOutPath, type }) =>
    api.get(`login/${type}`, { params: { callOutPath } }),
  );
  const addToast = useAddToast();
  const handleMutationError = useHandleMutationError();

  return useMutation({
    mutationFn,
    onError: (error) => {
      handleMutationError(error);
      addToast({
        type: 'error',
        content: error.message,
      });
    },
  });
};
